const SvgNetworking1 = (props) => (
  <>
    <defs />
    <path d="M144 40v104M144 246.03v136.65" strokeMiterlimit={10} fill="none" stroke="#001d6c" strokeWidth="3px" />
    <path
      d="M192.03 144h-80.98c-9.21-.01-15.07 6.23-15.07 15.44V320"
      strokeLinejoin="round"
      fill="none"
      stroke="#001d6c"
      strokeWidth="3px"
    />
    <path d="M96 96H0M96 192H6" strokeMiterlimit={10} fill="none" stroke="#001d6c" strokeWidth="3px" />
    <circle cx={96} cy={320} r={8} fill="#2666f4" strokeWidth={0} />
    <path
      d="M144 235c2.76 0 5 2.24 5 5s-2.24 5-5 5-5-2.24-5-5 2.24-5 5-5m0-3c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8ZM144 27c2.76 0 5 2.24 5 5s-2.24 5-5 5-5-2.24-5-5 2.24-5 5-5m0-3c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8ZM0 187c2.76 0 5 2.24 5 5s-2.24 5-5 5-5-2.24-5-5 2.24-5 5-5m0-3c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8Z"
      fill="#001d6c"
      strokeWidth={0}
    />
    <circle cx={96} cy={96} r={8} fill="#2666f4" strokeWidth={0} />
    <path
      d="M240 377.89v-185.9M192.19 185l-.38-182"
      strokeMiterlimit={10}
      fill="none"
      stroke="#001d6c"
      strokeWidth="3px"
    />
    <path
      d="M191.88 192.36h80.66c9.29.01 15.56-6.29 15.58-15.58V53.7"
      strokeLinejoin="round"
      fill="none"
      stroke="#001d6c"
      strokeWidth="3px"
    />
    <path d="M293 288h90M290 144h88" strokeMiterlimit={10} fill="none" stroke="#001d6c" strokeWidth="3px" />
    <path
      d="M288 43c2.76 0 5 2.24 5 5s-2.24 5-5 5-5-2.24-5-5 2.24-5 5-5m0-3c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8Z"
      fill="#001d6c"
      strokeWidth={0}
    />
    <circle cx={192} cy={192} r={8} fill="#2666f4" strokeWidth={0} />
    <path
      d="M240 379c2.76 0 5 2.24 5 5s-2.24 5-5 5-5-2.24-5-5 2.24-5 5-5m0-3c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8ZM384 139c2.76 0 5 2.24 5 5s-2.24 5-5 5-5-2.24-5-5 2.24-5 5-5m0-3c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8ZM288 283c2.76 0 5 2.24 5 5s-2.24 5-5 5-5-2.24-5-5 2.24-5 5-5m0-3c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8Z"
      fill="#001d6c"
      strokeWidth={0}
    />
    <circle cx={192} r={8} fill="#001d6c" strokeWidth={0} />
    <circle cx={144} cy={384} r={8} fill="#001d6c" strokeWidth={0} />
    <circle cy={96} r={8} fill="#001d6c" strokeWidth={0} />
    <circle cx={384} cy={288} r={8} fill="#001d6c" strokeWidth={0} />
  </>
);

export default SvgNetworking1;
